<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Сверка итогов
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.created"
                label="Дата создания"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.number"
                label="Номер"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.clientName"
                label="Наименоваие клиента"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              sm="6"
            >
              <v-text-field
                v-model="form.pointNumber"
                label="Номер точки"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.pointName"
                label="Наименоваие точки"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.placeName"
                label="Местоположение"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="form.slip"
                label="Слип"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { JustpayFinalreconService } from "@/views/loyalty/shared/services/justpay-finalrecon-service"

export default {
  data: () => ({
    items: [],
    form: {
      created: null,
      clientName: null,
      number: null,
      placeName: null,
      pointName: null,
      pointNumber: null,
      slip: null
    },
    justpayFinalreconService: null,
  }),
  beforeMount () {
    this.justpayFinalreconService = new JustpayFinalreconService()
  },
  async mounted () {
    const id = this.$route.query.id
    const item = await this.justpayFinalreconService.getList({ id: id })
    this.form = item.value.data[0]
  }
}
</script>
<style scoped>

</style>
